module.exports = __webpack_public_path__ + "img/gears-laptop-magnifier.8c869155.svg";